import styled from "styled-components";

export const AcademyCardMobileContainer = styled.div`
    margin-top: 20vh;
    position: relative;
    border-radius: 12px;
    background: var(--white, #FFF);
    /* Drop Shadow Style */
    color: var(--academy-medium-orange, #E65300);
    text-align: center;
    /* Expandable Sub Title */
    font-style: normal;
    line-height: normal;
    /* width: 276px; */
    display: flex;
    flex-direction: column;
    justify-content: flex-end;
    align-items: center;
    cursor: pointer;
    width: 80%;
    padding-top: 5vh;
    left: 50%;
    transform: translateX(-50%);
    box-shadow: 2px 2px 15px 2px rgba(0, 0, 0, 0.20);
    @media screen and (min-width: 801px ) {
        display: none;
    }
`;

export const ProductCol = styled.div`
    display: flex;
    flex-direction: column;
    height: 100%;
    justify-content: space-between;
    text-align: center;
    align-items: center;
    margin-bottom: 5vh;
    margin-top: 4vh;
`;

export const ProductTitle = styled.div`
    margin-top: 1vh;
    /* width: 50vw; */
    padding-inline: 15%;
    color: var(--Consulting-Light-Red, #E20D1A);
    text-align: center;
    /* Resp-Sub-title */
	font-family: "HelveticaLt", Arial, sans-serif;
    font-size: 5vw;
    font-size: 20px;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
    text-transform: uppercase;
    z-index: 1;
`;

export const ProductDesc = styled.div`
    margin-top: 3vh;
    /* width: 45vw; */
    padding-inline: 16%;
    color: var(--Black, #000);
	text-align: center;
	font-family: "HelveticaLt", Arial, sans-serif;
	font-size: 4vw;
	font-size: 16px;
	font-style: normal;
	font-weight: 400;
`;

export const CardBottom = styled.div`
    height: 35px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    text-align: center;
    align-items: center;
    width: 100%;
    background-color: #f0f0f0;
    border-bottom-left-radius: 12px;
    border-bottom-right-radius: 12px;
`;

export const AcademyEyeIconMobile = styled.img`
  position: absolute;
  width: 150px;
  top: -80px;
  left: 50%;
  transform: translateX(-50%);
`;